<template>
  <div id="wind-hazard-getting-started">
    <the-top-bar showUser />
    <div class="row">
      <info-cards :data-info-cards="infoCardsData" />
    </div>
  </div>
</template>
<script>
import TheTopBar from '@/components/TheTopBar'
import InfoCards from '@/components/TheSurveysGettingStartedInformation'
import { mapState } from 'vuex'
export default {
  name: 'WindHazardGettingStarted',
  components: {
    TheTopBar,
    InfoCards,
  },
  props: {},
  data() {
    return {
      infoCardsData: [
        {
          title: "Wind Hazard",
          description:
            "A checklists that include key features of a house's roof, windows, doors, walls and foundation that are important to making a house more resilient to hurricane-force winds. Examine your house and check the boxes next to the features present or description that best matches the condition of your house.",
          buttonText: "Next",
          cardClass: "",
          wrapperClass: "col s12",
          route: "",
        },
        {
          title: "Lets Get Started",
          description:
            "Based on the results of the assessment, in the next step you will predict the expected impact level to your home from Category 5 hurricane-force winds.",
          buttonText: "Click To Begin",
          cardClass: "",
          wrapperClass: "col s12",
          route: "WindHazardSurvey",
        },
      ],
    };
  },

  created() {
    
    //if (this.surveyStarted) 
   // this.$router.push({ name: "WindHazardSurvey" });
  },
  mounted() {
    // this.$router.push({ name: "WindHazardSurvey" });
  },
  computed: {
    ...mapState({
      surveyStarted: (state) => state.Surveys.windHazardStarted,
    }),
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
#wind-hazard-getting-started {
}
</style>
